// extracted by mini-css-extract-plugin
module.exports = {"messages":"Messages_messages__2SY23","wrapper":"Messages_wrapper__3J4Th","button":"Messages_button__1KbBS","list":"Messages_list__1iJrI"};